import { Component, Injectable, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lds-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.css'],
    standalone: false
})

@Injectable({
  providedIn: 'root'
})
export class PopupComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PopupComponent>, private dialog: MatDialog) { }

  ngOnInit() {
  }

  onFormatClick() {
    this.dialogRef.close(true);
  }

  onNoFormatClick() {
    this.dialogRef.close(false);
  }

  open(){
    return this.dialog.open(PopupComponent);
  }

}


